import { render, staticRenderFns } from "./form.vue?vue&type=template&id=d39ec140&"
import script from "./form.vue?vue&type=script&lang=js&"
export * from "./form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/borno-cct/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d39ec140')) {
      api.createRecord('d39ec140', component.options)
    } else {
      api.reload('d39ec140', component.options)
    }
    module.hot.accept("./form.vue?vue&type=template&id=d39ec140&", function () {
      api.rerender('d39ec140', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/setting/state/form.vue"
export default component.exports